export default "__VITE_ASSET__DaV65sXL__"